$(function() {
    $(document).on('click', '.js-options-btn', function openOption() {
        let $options = $(this).siblings('.js-options');
        const target = $(this).data('target');

        if (target) {
            $options = $('.js-options[data-id="' + target + '"]');
        }

        const moreButtons = $('.js-filters-more-show');

        if (!$(this).hasClass('js-toggle-more')) {
            $('.js-category-content-more').removeClass('is-open'); $('.js-category-content-results').addClass('is-open');
        }

        if ($(this).hasClass('is-open')) {
            $(this).removeClass('is-open');
            $($options).removeClass('is-open');

            for (var i = 0; i < moreButtons.length; i++) {
                $(moreButtons[i])
                    .text('Show ' + $(moreButtons[i]).val() + ' more');
            }

            return;
        }

        $('.js-options-btn, .js-options').removeClass('is-open');

        $(this).addClass('is-open');
        $($options).addClass('is-open');
    });

    $(document).on('click', '.js-option', function() {
        let $options = $(this).closest('.js-options');
        const target = $(this).data('target');

        if (target) {
            $options = $('.js-options[data-id="' + target + '"]');
        }

        $($options).removeClass('is-open');
    });

    $(document).click(function closeBlocks(e) {
        const optionsBtnCheck = $(e.target).closest('.js-options-btn').length;
        const optionsCheck = $(e.target).closest('.js-options').length;

        if (!optionsBtnCheck && !optionsCheck) {
            $('.js-options-btn, .js-options').removeClass('is-open');
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/options.js